import React, { Component } from "react";
import { Card, CardHeader, CardBody, Stack, Box } from "@chakra-ui/react";

import { JsonViewer } from '@textea/json-viewer'

import _ from "lodash";

function toFixed(num, fixed) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  return num.toString().match(re)[0];
}

let omitByDeep = (obj, shouldOmit, convertBool, convertFloat) => {
  obj = _.clone(obj);
  _.forEach(obj, (value, key) => {
    if (shouldOmit(value, key)) {
      delete obj[key];
    }
    if (convertBool) {
      if (_.isBoolean(value)) {
        obj[key] = value ? "YES" : "NO";
      }
    }
    if (convertFloat) {
      if (Number.isFinite(value)) {
        if (!Number.isInteger(value)) {
          // must be a float?
          obj[key] = toFixed(value, 2);
        }
      }
    }
    if (_.isPlainObject(value)) {
      obj[key] = omitByDeep(value, shouldOmit, convertBool, convertFloat);
    }
  });
  return obj;
};

export default class OrgConfigDetailCard extends Component 
{



  render() {
    const schemaJsonSource = this.props.orgConfigJson
      ? omitByDeep(
        this.props.orgConfigJson,
        (v) => v === null || v === undefined || v === "" || v === 0,
        true,
        true
      ) // immutable. Will NOT change original rowData
      : { "data": {}, "score": {}, "identifiers": {} };
    if (this.props.orgConfigJson) {
      //console.log(this.props.schemaJson);
      // users do not want to see OUI. I'm doing all of this JUST so I can change the label! Stupid.
      //schemaJson.data.underInspection = displayGridRow.data.oui; // again, will NOT change the original object
      //delete displayGridRow.data.oui;
      //delete displayGridRow.data.readOnly;
    }


    return (
      <Box p='4'>
        <Card>
          <CardHeader align="center">Org Configuration Detail</CardHeader>
          <CardBody>
            <div style={{ width: "100%", height: "100%" }}>
              <Stack direction={['column', 'row']}>
                <Box>
                    <JsonViewer
                        value={this.props.orgConfigJson}
                    />
                </Box>

              </Stack>
            </div>
          </CardBody>
        </Card>
      </Box>
    );
  }
}
